import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { ReportStatusResponse } from 'services/tenantManagementService';
import { REPORT_STATUS_SET, REPORT_STATUS_FETCHING } from './action';

export const reportStatusReducer = (state = new PersistItemsReducer<ReportStatusResponse>(), action: PersistItemsActionType<ReportStatusResponse> | FetchingActionType): PersistItemsReducer<ReportStatusResponse> => {
	switch (action.type) {
		case REPORT_STATUS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case REPORT_STATUS_SET:
			const { items } = action as PersistItemsActionType<ReportStatusResponse>;

			const itemsMap: { [id: number]: ReportStatusResponse } = items.reduce(
                (map: { [id: number]: ReportStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
